module.exports = __webpack_public_path__ + "static/media/sms4.a6e8dccd.png";